import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import {
  MRO_SEARCH_ITEMS,
  MRO_CATALOG_GET_PRODUCT_ITEM,
} from '@/store/graphql/queries/cat4mro';
import { MRO_SAVE_SEARCH_WORDS, NEW_SAVE_SEARCH_WORDS } from '@/store/graphql/mutations/cat4mro';

const cat4mroCataloger = {
  namespaced: true,
  state: {
    search: {
      data: [],
    },
    saveSearch: {
      data: [],
      selectedItem: {},
      searchKeywords: '',
    },
    providers: {
      data: [],
    },
    everySavedSearchID: [],
    organizationIdCreateMaterial: null,
  },
  actions: {
    async search({ commit, dispatch }, searchData) {
      try {
        const searchQuery = {
          fetchPolicy: 'network-only',
          query: MRO_SEARCH_ITEMS,
          variables: searchData,
        };
        // If page is 1 then save the search data
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          const data = result.data;
          commit('SET_SAVE_CAT4MRO_SEARCH', {
            data: data.data,
            searchKeywords: searchData.keywords,
          });
          commit('SET_CAT4MRO_SEARCH', {
            data: data.data,
            count: data.all.aggregate.count,
          });
          await dispatch('newSaveSearch', { filters: searchData });
          // if (data.all.aggregate.count > 0) {
          //   dispatch('saveSearch', searchData);
          // }
        } else {
          throw new Error('searchCatalogItems data is null');
        }
      } catch (error) {
        window.console.error(error);
      }
    },
    async saveSearch(store, filters) {
      try {
        const searchData = JSON.parse(JSON.stringify(filters));
        searchData.words = searchData.keywords;
        delete searchData.keywords;
        const insertMutation = {
          mutation: MRO_SAVE_SEARCH_WORDS,
          variables: searchData,
        };
        await apolloClient.mutate(insertMutation);
      } catch (error) {
        throw new Error(error);
      }
    },
    async newSaveSearch({ state, commit }, { filters, isSearchingProviders = false }) {
      try {
        const searchData = JSON.parse(JSON.stringify(filters));
        if (searchData.keywords.replace(/\s/g, '').length === 0) {
          return null;
        }
        searchData.category_id = Array.isArray(searchData.category_id) ? searchData.category_id[0] : null;
        searchData.words = searchData.keywords;
        delete searchData.keywords;
        const insertMutation = {
          mutation: NEW_SAVE_SEARCH_WORDS,
          variables: searchData,
        };
        const result = await apolloClient.mutate(insertMutation);
        if (result && result.data && result.data.newSearchStatistics) {
          const dataArray = result.data.newSearchStatistics.returning;
          if (!isSearchingProviders && Array.isArray(dataArray) && dataArray.length > 0) {
            const everySavedSearchIDLocal = [...state.everySavedSearchID];
            everySavedSearchIDLocal.push(dataArray[0].id);
            commit('SET_EVERY_SAVED_SEARCH_ID', everySavedSearchIDLocal);
          }
        }
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getProduct(state, productId) {
      try {
        const searchQuery = {
          query: MRO_CATALOG_GET_PRODUCT_ITEM,
          variables: {
            productId,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          return result.data.item_by_pk;
        }
      } catch (error) {
        window.console.error(error);
      }
      return {};
    },
  },
  mutations: {
    SET_CAT4MRO_SEARCH(state, { data, count }) {
      Vue.set(state.search, 'data', data);
      Vue.set(state.search, 'count', count);
    },
    SET_SAVE_CAT4MRO_SEARCH(state, saveSearch) {
      if (saveSearch.data) {
        Vue.set(state.saveSearch, 'data', saveSearch.data);
        Vue.set(state.saveSearch, 'searchKeywords', saveSearch.searchKeywords);
      } else {
        Vue.set(state.saveSearch, 'selectedItem', saveSearch.selectedItem);
      }
    },
    SET_CAT4MRO_PROVIDERS_SEARCH(state, { data }) {
      Vue.set(state.providers, 'data', data);
    },
    SET_EVERY_SAVED_SEARCH_ID(state, data) {
      Vue.set(state, 'everySavedSearchID', data);
    },
    SET_ORGANIZATION_ID_CREATE_MATERIAL_CAT4MRO(state, organizationIdCreateMaterial) {
      state.organizationIdCreateMaterial = organizationIdCreateMaterial;
    },
  },
  getters: {
    everySavedSearchIDGetter: state => state.everySavedSearchID,
  },
};

export default cat4mroCataloger;



// WEBPACK FOOTER //
// ./src/store/modules/cataloger/cat4mro.js